export const features4K = [
  {
    title: "UHD 4K 해상도",
    description: "3840x2160 픽셀의 초고화질로 선수의 미세한 움직임까지 선명하게 포착합니다.",
    icon: "ri-hd-line",
  },
  {
    title: "HDR 컬러",
    description: "HDR 기술로 풍부한 색감과 깊이 있는 명암비를 제공하여 실제 경기장 같은 몰입감을 선사합니다.",
    icon: "ri-palette-line",
  },
  {
    title: "60fps 부드러운 화면",
    description: "초당 60프레임의 부드러운 영상으로 빠른 공의 움직임과 순간적인 플레이도 놓치지 않습니다.",
    icon: "ri-film-line",
  },
  {
    title: "다중 카메라 앵글",
    description: "다양한 카메라 앵글을 자유롭게 전환하며 나만의 시점으로 경기를 감상할 수 있습니다.",
    icon: "ri-camera-switch-line",
  },
];

export const supportedLeagues4K = [
  "프리미어리그",
  "라리가",
  "분데스리가",
  "세리에A",
  "챔피언스리그",
  "Europa League",
  "MLB",
  "NBA",
  "KBO",
  "KBL",
  "LCK",
  "LPL",
];